/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Niveau de précision de la suggestion, tel que renvoyé par le géocodeur (`type`) :\nnuméro dans la voie, voie, lieu-dit, ou commune (utile comme repli GPS d\'un bien rural).\n
 */
export const adressePrecisionSchema = z.enum(["housenumber", "street", "locality", "municipality"]).describe("Niveau de précision de la suggestion, tel que renvoyé par le géocodeur (`type`) :\nnuméro dans la voie, voie, lieu-dit, ou commune (utile comme repli GPS d'un bien rural).\n")